var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "resource_add_cla",
      attrs: {
        "append-to-body": true,
        title: _vm.title,
        visible: _vm.dialog_visible
      },
      on: {
        close: _vm.onCancel,
        "update:visible": function($event) {
          _vm.dialog_visible = $event
        }
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              attrs: {
                model: _vm.params,
                rules: _vm.rules,
                "label-width": "140px"
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: _vm.gutter } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("common.name"), prop: "name" }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("common.nameRequire")
                            },
                            model: {
                              value: _vm.params.name,
                              callback: function($$v) {
                                _vm.$set(_vm.params, "name", $$v)
                              },
                              expression: "params.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("resource.resourceType"),
                            prop: "resourceType"
                          }
                        },
                        [
                          _c("zk-dictionary-select", {
                            attrs: { type: "resourceType" },
                            model: {
                              value: _vm.params.resourceType,
                              callback: function($$v) {
                                _vm.$set(_vm.params, "resourceType", $$v)
                              },
                              expression: "params.resourceType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.params.resourceType + "" === "5" ||
              _vm.params.resourceType + "" === "1"
                ? _c(
                    "el-row",
                    { attrs: { gutter: _vm.gutter } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "URL", prop: "url" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("resource.urlRequire")
                                },
                                model: {
                                  value: _vm.params.url,
                                  callback: function($$v) {
                                    _vm.$set(_vm.params, "url", $$v)
                                  },
                                  expression: "params.url"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: _vm.gutter } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: _vm.gutter } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.status"),
                                prop: "status"
                              }
                            },
                            [
                              _c("zk-dictionary-select", {
                                staticStyle: { widith: "155px" },
                                attrs: {
                                  type: "status",
                                  placeholder: _vm.$t("common.select")
                                },
                                model: {
                                  value: _vm.params.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.params, "status", $$v)
                                  },
                                  expression: "params.status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.i18nKey"),
                                prop: "i18nKey"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.i18nKeyRequire")
                                },
                                model: {
                                  value: _vm.params.i18nKey,
                                  callback: function($$v) {
                                    _vm.$set(_vm.params, "i18nKey", $$v)
                                  },
                                  expression: "params.i18nKey"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: _vm.gutter } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("resource.sortNo"),
                                prop: "sortNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("resource.intRequire")
                                },
                                model: {
                                  value: _vm.params.sortNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.params, "sortNo", $$v)
                                  },
                                  expression: "params.sortNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.params.resourceType + "" !== "5"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("resource.icon"),
                                    prop: "icon"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "" },
                                    model: {
                                      value: _vm.params.icon,
                                      callback: function($$v) {
                                        _vm.$set(_vm.params, "icon", $$v)
                                      },
                                      expression: "params.icon"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticStyle: { text: "center" } }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: "https://fontawesome.com/icons"
                                    }
                                  },
                                  [_vm._v("Font Awesome Free 5.8.2")]
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: _vm.gutter } },
                [
                  _vm.params.resourceType + "" === "2" ||
                  _vm.params.resourceType + "" === "3" ||
                  _vm.params.resourceType + "" === "4"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("resource.resourceEvent"),
                                prop: "resourceEvent"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "" },
                                model: {
                                  value: _vm.params.resourceEvent,
                                  callback: function($$v) {
                                    _vm.$set(_vm.params, "resourceEvent", $$v)
                                  },
                                  expression: "params.resourceEvent"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.params.resourceType + "" === "1"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("resource.routerName"),
                                prop: "routerName"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("resource.routerNameRule")
                                },
                                model: {
                                  value: _vm.params.routerName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.params, "routerName", $$v)
                                  },
                                  expression: "params.routerName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.params.resourceType + "" === "2" ||
              _vm.params.resourceType + "" === "3"
                ? _c(
                    "el-row",
                    { attrs: { gutter: _vm.gutter } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("resource.btnGroup"),
                                prop: "groupName"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "resource.btnGroupRequire"
                                  )
                                },
                                model: {
                                  value: _vm.params.groupName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.params, "groupName", $$v)
                                  },
                                  expression: "params.groupName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("resource.btnType"),
                                prop: "buttonType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "resource.btnTypeRequire"
                                    )
                                  },
                                  model: {
                                    value: _vm.params.buttonType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.params, "buttonType", $$v)
                                    },
                                    expression: "params.buttonType"
                                  }
                                },
                                _vm._l(_vm.options, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.params.resourceType + "" === "2" ||
              _vm.params.resourceType + "" === "3"
                ? _c(
                    "el-row",
                    { attrs: { gutter: _vm.gutter } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("resource.btnStyle"),
                                prop: "buttonStyle"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "resource.btnStyleRequire"
                                    )
                                  },
                                  model: {
                                    value: _vm.params.buttonStyle,
                                    callback: function($$v) {
                                      _vm.$set(_vm.params, "buttonStyle", $$v)
                                    },
                                    expression: "params.buttonStyle"
                                  }
                                },
                                _vm._l(_vm.optionStyle, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("resource.btnEffect") } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    round: _vm.params.buttonStyle === "round",
                                    icon:
                                      _vm.params.icon +
                                      " zk-icon-" +
                                      _vm.params.icon,
                                    circle: _vm.params.buttonStyle === "circle",
                                    plain: _vm.params.buttonStyle === "plain",
                                    type: _vm.params.buttonType
                                  }
                                },
                                [_vm._v(_vm._s(_vm.params.name))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: _vm.gutter } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "150px",
                            label: _vm.$t("resource.parentResource"),
                            prop: "parentId"
                          }
                        },
                        [
                          _c("zk-resource-tree", {
                            ref: "resTree",
                            attrs: {
                              parentId: _vm.params.parentId,
                              treeData: _vm.treeData
                            },
                            on: { nodeClick: _vm.nodeClick }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.onCancel } }, [
            _vm._v(_vm._s(_vm.$t("common.cancel")))
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.confirm")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-466dd8a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466dd8a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/addOrUpdateResource/src/main.vue
// module id = null
// module chunks = 